export default __webpack_public_path__ + "8c391358e9cf6a84ee684ad3bba2eaa6.webp";